<template>
  <v-card class="appointmentcard pa-2">
    <v-flex class="items">
      <v-tooltip bottom left content-class="portal-tooltip">
        <template v-slot:activator="{ on, attrs }">
          <div id="truncated" class="appointmentheader">
            <v-icon class="mr-2 mb-1" color="white">widgets</v-icon
            ><span
              class="subtitle-1 font-weight-bold"
              v-bind="attrs"
              v-on="on"
              >{{ appServiceName }}</span
            >
          </div>
        </template>
        <span>{{ appServiceName }}</span>
      </v-tooltip>
      <span class="appointmentchip">
        <v-chip
          class="font-weight-bold text-uppercase appointment-state-chip"
          :color="appStateChipColor"
          small
        >
          {{ $t("status." + appState) }}
        </v-chip></span
      >
    </v-flex>
    <v-row no-gutters class="appointment-info">
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="hfOfficeName">
        <v-row no-gutters>
          <v-icon color="white" :class="isSanimpresaOffice ? 'mr-2' : ''"
            >fas fa-clinic-medical</v-icon
          >
          <sanimpresa-tooltip
            :isSanimpresa="isSanimpresaOffice"
            :tooltipText="'sanimpresaTooltip'"
            :iconColor="'w'"
            :iconDimension="'20px'"
          ></sanimpresa-tooltip
          ><span class="caption font-weight-bold">{{ hfOfficeName }}</span>
        </v-row>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" v-if="appDoctor">
        <v-icon color="white" class="mr-1">fas fa-stethoscope</v-icon>
        <span class="caption font-weight-bold">
          {{ appDoctor }}
        </span>
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="12"
        xl="12"
        v-if="hfOfficeAddress"
      >
        <v-icon color="white" class="mr-1">fas fa-map-marker-alt</v-icon>
        <span class="caption font-weight-bold link" @click.stop="goToMap()">
          {{ hfOfficeAddress }}
        </span>
      </v-col>
      <v-col
        cols="auto"
        xs="12"
        sm="12"
        md="8"
        lg="8"
        xl="8"
        v-if="appScheduleDate"
        ><v-icon color="white" class="mr-1">today</v-icon>
        <span class="caption font-weight-bold text-capitalize">
          {{ appScheduleDate }}
        </span>
      </v-col>
      <v-col cols="auto" xs="12" sm="12" md="8" lg="8" xl="8" v-else
        >&nbsp;</v-col
      >
      <v-col cols="auto" xs="12" sm="12" md="4" lg="4" xl="4" v-if="appIupCode">
        <v-icon color="white">confirmation_number</v-icon>
        <span class="caption font-weight-bold text-capitalize">
          {{ appIupCode }}
        </span>
      </v-col>
      <v-col cols="auto" xs="12" sm="12" md="4" lg="4" xl="4" v-else
        >&nbsp;</v-col
      >
    </v-row>
    <!-- Buttons -->
    <v-row no-gutters class="justify-end">
      <v-btn
        color="primary"
        class="font-weight-bold mr-2"
        rounded
        small
        depressed
        @click="edit"
        >{{ $t("appointmentDetails") }}</v-btn
      >
      <v-btn
        color="primary"
        class="font-weight-bold"
        rounded
        small
        depressed
        @click.stop="openVoucher"
        v-if="existsAppVoucherDoc"
        >{{ $t("downloadVoucherAppItem") }}</v-btn
      ></v-row
    >
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import SanimpresaTooltip from "./SanimpresaTooltip";

export default {
  components: {
    SanimpresaTooltip
  },
  props: {
    appointment: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {
    appId() {
      return this.appointment?.appointmentId || null;
    },
    appServiceName() {
      return this.appointment?.hService?.shortDescr || null;
    },
    appState() {
      return this.appointment?.state || null;
    },
    appStateChipColor() {
      if (this.appState) {
        switch (this.appState) {
          case "ACCEPTED":
          case "INBILL":
          case "DONE":
          case "DONE_NOTBILLABLE":
          case "TOBERESCHEDULED":
            return "success";
          case "PENDING":
          case "MEMBERCHANGE":
            return "warning";
          case "REQUESTCANCELLEDBYNEST":
          case "REQUESTCANCELLEDBYMEMBER":
          case "REQUESTCANCELLEDBYPORTAL":
          case "APPOINTMENTCANCELLEDBYNEST":
          case "APPOINTMENTCANCELLEDBYMEMBER":
          case "APPOINTMENTCANCELLEDBYPORTAL":
          case "APPOINTMENTCANCELLEDCONFIRMED":
          case "NOTDONE":
            return "error";
          default:
            return "primary";
        }
      }
      return "";
    },
    appScheduleDate() {
      if (this.appointment?.appointmentScheduleDate) {
        return dayjs(this.appointment.appointmentScheduleDate).format(
          "ddd DD/MM/YYYY - HH.mm"
        );
      }
      return null;
    },
    appIupCode() {
      return this.appointment?.iupCode || null;
    },
    appDoctor() {
      if (
        this.appointment?.doctorId &&
        this.appointment?.doctorId != "fake-doctor-id"
      ) {
        if (this.appointment.doctorName && this.appointment.doctorSurname) {
          return `${this.appointment.doctorName} ${this.appointment.doctorSurname}`;
        }
      }
      return null;
    },
    hfOfficeName() {
      return this.appointment?.hfOfficeName || null;
    },
    isSanimpresaOffice() {
      return this.appointment?.hfOfficeSanimpresa || false;
    },
    hfOfficeAddress() {
      return (
        this.appointment.hfOfficeAddress?.geoLocation?.formattedAddress || null
      );
    },
    hfOfficeLat() {
      return this.appointment?.hfOfficeLatitudeGPS || "";
    },
    hfOfficeLong() {
      return this.appointment.hfOfficeLongitudeGPS || "";
    },
    existsAppVoucherDoc() {
      return this.appointment?.voucherDocumentId || false;
    },
    appVoucherDocId() {
      if (this.existsAppVoucherDoc && this.appointment.voucherDocumentId) {
        return this.appointment.voucherDocumentId;
      }
      return null;
    },
    numOfInformations() {
      let appDataArray = [
        this.appScheduleDate,
        this.hfOfficeName,
        this.appIupCode,
        this.appDoctor
      ];
      return appDataArray.filter(d => d != null).length;
    }
  },
  methods: {
    edit() {
      this.$router.push({
        name: "bookingDetails",
        query: { id: this.appId }
      });
    },
    goToMap() {
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${this.hfOfficeLat},${this.hfOfficeLong}`,
        "_blank"
      );
    },
    openVoucher() {
      if (this.appVoucherDocId) {
        this.$store.dispatch(
          "appointments/openVoucherPreview",
          this.appVoucherDocId
        );
      }
    }
  }
};
</script>

<style scoped>
.appointmentcard {
  background: var(--special) !important;
  color: white !important;
  border-radius: 4px !important;
  margin: 2px !important;
}

.items {
  position: absolute;
  margin-top: 0px;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;
  display: flex;
  width: 880px;
}

#truncated {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.appointmentheader {
  max-width: 800px;
  margin-left: 2px;
}

.appointmentchip {
  max-width: 400px;
  height: 28px;
  margin-left: 8px;
  margin-right: 30px;
}

.appointment-info {
  width: 100%;
  padding-top: 40px;
  padding-bottom: 10px;
}
.appointment-info .v-icon {
  font-size: 15px;
  width: 20px;
  margin-right: 8px;
  text-align: center;
  justify-content: center;
}

.edit-btn:hover {
  color: var(--primary) !important;
}
.link {
  cursor: pointer;
  transition: all 0.2s ease;
}
.link:hover,
.link:hover .v-icon {
  color: var(--primary);
}
.col .caption {
  white-space: nowrap;
}
</style>
